module.exports = __webpack_public_path__ + "static/travelr_logo-f96b988f7154237797cea302e387b8fd.png";